/**
 * Low-battery alarm (feedback fb-mrwmsuxk-c). A flat phone is a flat chart
 * plotter, and on a long passage the one running the navigation is easy to
 * forget about, so a heads-up before it dies is worth having. Pure so the
 * threshold logic is testable without a device; a runner polls the battery and
 * feeds it in.
 *
 * On charge we deliberately stay quiet: the level is on its way up, so nagging
 * about it would just be noise. Only a draining battery below the limit fires.
 */

export interface BatteryAlarmInputs {
  enabled: boolean;
  /** Charge level, percent (0–100), or null when the device can't tell us. */
  levelPct: number | null;
  /** True when plugged in / charging. */
  charging: boolean;
  /** Warn at or below this percent. */
  thresholdPct: number;
}

/** The low-battery alarm, or null when it shouldn't fire. */
export function evaluateBatteryAlarm(i: BatteryAlarmInputs): { levelPct: number } | null {
  if (!i.enabled) return null;
  if (i.levelPct == null) return null;
  // Don't nag while charging — the level is climbing back up.
  if (i.charging) return null;
  return i.levelPct <= i.thresholdPct ? { levelPct: i.levelPct } : null;
}
